/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EnteCreateDTO,
  EnteDTO,
  EnteUpdateDTO,
  OperatoreDTO,
  ProblemDetails,
} from '../models/index';
import {
    EnteCreateDTOFromJSON,
    EnteCreateDTOToJSON,
    EnteDTOFromJSON,
    EnteDTOToJSON,
    EnteUpdateDTOFromJSON,
    EnteUpdateDTOToJSON,
    OperatoreDTOFromJSON,
    OperatoreDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DeleteEnteRequest {
    enteId: string;
    tenantId: string;
}

export interface GetEnteByIdRequest {
    enteId: string;
    tenantId: string;
}

export interface GetEntiRequest {
    tenantId: string;
}

export interface GetOperatoriByEnteRequest {
    enteId: string;
    tenantId: string;
}

export interface InsertEnteRequest {
    tenantId: string;
    enteCreateDTO?: EnteCreateDTO;
}

export interface UpdateEnteRequest {
    enteId: string;
    tenantId: string;
    enteUpdateDTO?: EnteUpdateDTO;
}

/**
 * 
 */
export class EntiApi extends runtime.BaseAPI {

    /**
     */
    async deleteEnteRaw(requestParameters: DeleteEnteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['enteId'] == null) {
            throw new runtime.RequiredError(
                'enteId',
                'Required parameter "enteId" was null or undefined when calling deleteEnte().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteEnte().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Enti/{enteId}`.replace(`{${"enteId"}}`, encodeURIComponent(String(requestParameters['enteId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteEnte(requestParameters: DeleteEnteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEnteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getEnteByIdRaw(requestParameters: GetEnteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnteDTO>> {
        if (requestParameters['enteId'] == null) {
            throw new runtime.RequiredError(
                'enteId',
                'Required parameter "enteId" was null or undefined when calling getEnteById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getEnteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Enti/{enteId}`.replace(`{${"enteId"}}`, encodeURIComponent(String(requestParameters['enteId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnteDTOFromJSON(jsonValue));
    }

    /**
     */
    async getEnteById(requestParameters: GetEnteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnteDTO> {
        const response = await this.getEnteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEntiRaw(requestParameters: GetEntiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EnteDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getEnti().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Enti`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EnteDTOFromJSON));
    }

    /**
     */
    async getEnti(requestParameters: GetEntiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EnteDTO>> {
        const response = await this.getEntiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOperatoriByEnteRaw(requestParameters: GetOperatoriByEnteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OperatoreDTO>>> {
        if (requestParameters['enteId'] == null) {
            throw new runtime.RequiredError(
                'enteId',
                'Required parameter "enteId" was null or undefined when calling getOperatoriByEnte().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getOperatoriByEnte().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Enti/{enteId}/Operatori`.replace(`{${"enteId"}}`, encodeURIComponent(String(requestParameters['enteId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OperatoreDTOFromJSON));
    }

    /**
     */
    async getOperatoriByEnte(requestParameters: GetOperatoriByEnteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OperatoreDTO>> {
        const response = await this.getOperatoriByEnteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertEnteRaw(requestParameters: InsertEnteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EnteDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertEnte().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Enti`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EnteCreateDTOToJSON(requestParameters['enteCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnteDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertEnte(requestParameters: InsertEnteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EnteDTO> {
        const response = await this.insertEnteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateEnteRaw(requestParameters: UpdateEnteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['enteId'] == null) {
            throw new runtime.RequiredError(
                'enteId',
                'Required parameter "enteId" was null or undefined when calling updateEnte().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateEnte().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Enti/{enteId}`.replace(`{${"enteId"}}`, encodeURIComponent(String(requestParameters['enteId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EnteUpdateDTOToJSON(requestParameters['enteUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateEnte(requestParameters: UpdateEnteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEnteRaw(requestParameters, initOverrides);
    }

}
